import { createFileRoute } from '@tanstack/react-router';

import { DealsTable } from '../features/demand/deals/components/DealsTable';
import { dealsRouteSearchSchema } from '../features/demand/deals/routeSearch';

export const Route = createFileRoute('/demand/deals/')({
  validateSearch: dealsRouteSearchSchema,
  component: DealsTable,
});
